import React, { useState, useEffect } from "react";
import axios from "axios";
import io from "socket.io-client";
import moment from "moment";
import "moment/locale/tr";
import { toast, Flip } from "react-toastify";
import { useAlert } from "react-alert";
import { useHistory } from "react-router-dom";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import SwitchButton from "bootstrap-switch-button-react";
import { Done, Close, Visibility } from "@material-ui/icons";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import IstaCarousel from "../components/owl-carousel";
import TabBar from "../components/tab-bar";
import AllOrders from "../components/all-orders";
import CancelOrders from "../components/cancel-orders";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  label: {
    // fontFamily: "cursive",
    fontSize: 14,
  },
  control: {
    "&$checked": {
      color: "green",
    },
  },
}));

const Order = () => {
  toast.configure();
  const classes = useStyles();
  const alert = useAlert();
  let history = useHistory();
  const [token, setToken] = useState("");
  const [data, setData] = useState([]);
  const [resInfo] = useState(JSON.parse(localStorage.getItem("login")) || "");
  const [resId, setResId] = useState("");
  const [restaurantState, setRestaurantState] = useState(false);
  const [courierState, setCourierState] = useState(false);
  const [autoConfirm, setAutoConfirm] = useState(false);
  const [portionName, setPortionName] = useState("");
  const [showType, setShowType] = useState(0);
  const [value, setValue] = useState("Restoran kapalı");
  const [orderCancelId, setOrderCancelId] = useState("");
  const [show, setShow] = useState(false);
  const [totalOrder, setTotalOrder] = useState(0);
  const [todayOrder, setTodayOrder] = useState(0);
  const [totalOrderPrice, setTotalOrderPrice] = useState(0);
  const [todayOrderPrice, setTodayOrderPrice] = useState(0);
  const [cancelReason, setCancelReason] = useState([]);
  const [chosenModalItem, setChosenModalItem] = useState("");
  const [butonDisable, setButonDisable] = useState(false);
  const [cancelButonDisable, setCancelButonDisable] = useState(false);

  useEffect(() => {
    getState();
    getToken();
  }, []);

  useEffect(() => {
    const socket = io("https://getirs2.sambapos.com");
    socket.on("get-order", (getOrder) => {
      if (getOrder.licence_email === resInfo.licenseEmail) {
        if (getOrder.status === "newOrder") {
          getToken();
          getList();
        } else if (getOrder.status === "sambastatus") {
          toast.info(`Sambapos kapalı.Otomatik onay devre dışı bırakıldı.`, {
            position: "bottom-left",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            transition: Flip,
          });
          setAutoConfirm(false);
        } else if (getOrder.status === "state-changes") {
          toast.error(
            `Sipariş onaylanamadı.Otomatik onay kapatıldı.Daha sonra tekrar deneyiniz.`,
            {
              position: "bottom-left",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              transition: Flip,
            }
          );
          setAutoConfirm(false);
        }
      }
    });
  }, []);

  useEffect(() => {
    getList();
  }, [token, autoConfirm]);

  useEffect(() => {
    getIsta();
  }, [data]);

  const getToken = async () => {
    await axios
      .post("https://getirs2.sambapos.com/auth", {
        appsecretKey: resInfo.appsecretKey,
        restaurantsecretKey: resInfo.restaurantsecretKey,
      })
      .then((resp) => {
        setResId(resp.data.restaurantId);
        setToken(resp.data.token);
      })
      .catch((err) => {
        alert.show(err.response.data.error);
      });
  };

  const getState = async () => {
    await axios
      .post("https://getirs2.sambapos.com/customers/state", {
        emailState: resInfo.email,
      })
      .then((resp) => {
        setRestaurantState(resp.data.restaurant_state);
        setCourierState(resp.data.courier_state);
        setAutoConfirm(resp.data.auto_confirm);
        setPortionName(resp.data.portion);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getList = async () => {
    await axios
      .post("https://getirs2.sambapos.com/v1", {
        resId,
      })
      .then((resp) => {
        setData(resp.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const admitButton = async (verifyOrder) => {
    setButonDisable(true);

    await axios
      .post("https://getirs2.sambapos.com/v1/manuelAdmit", {
        l_email: resInfo.licenseEmail,
        resId: verifyOrder.restaurant_id,
        id: verifyOrder.order_id,
        token,
      })
      .then((resp) => {
        if (resp.data === "Sipariş Onaylandı") {
          toast.success(` 👍 ${resp.data}`, {
            position: "bottom-left",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            transition: Flip,
          });
        } else if (resp.data === "Sambapos Kapalı") {
          toast.info(`${resp.data}.İşlem Yapılamıyor.`, {
            position: "bottom-left",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            transition: Flip,
          });
        } else if (resp.data === "Sipariş Onaylanamadı") {
          toast.info(
            `Getir servislerine ulaşılamadı.Daha sonra tekrar deneyiniz.`,
            {
              position: "bottom-left",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              transition: Flip,
            }
          );
        }
        setButonDisable(false);
      });
  };

  const cancelOptions = async (orderId) => {
    setShow(true);
    setOrderCancelId(orderId);
    await axios
      .post(
        `https://getirs2.sambapos.com/food-orders/${orderId}/cancel-options`,
        {},
        {
          headers: {
            token: token,
          },
        }
      )
      .then((resp) => {
        setCancelReason(resp.data);
      })
      .catch((err) => {
        alert.show(err.response.data.error);
      });
  };

  const getIsta = () => {
    let totalPrice = 0;
    let totalOrderCount = 0;
    let todayPrice = 0;
    let todayOrderCount = 0;
    data.map((ıstaData) => {
      const today = moment().format("L");
      const lastMonday = moment().startOf("isoWeek").format("L");
      const orderDate = moment(ıstaData.createdAt).format("L");
      if (orderDate >= lastMonday) {
        totalOrderCount = totalOrderCount + 1;
        totalPrice =
          totalPrice +
          parseInt(
            ıstaData.total_discounted_price !== null
              ? ıstaData.total_discounted_price
              : ıstaData.total_price
          );

        setTotalOrderPrice(totalPrice);
        setTotalOrder(totalOrderCount);
      }
      if (orderDate === today) {
        todayOrderCount = todayOrderCount + 1;
        todayPrice =
          todayPrice +
          parseInt(
            ıstaData.total_discounted_price !== null
              ? ıstaData.total_discounted_price
              : ıstaData.total_price
          );
        setTodayOrderPrice(todayPrice);
        setTodayOrder(todayOrderCount);
      }
    });
  };

  const cancelButton = async (cancelNote) => {
    setCancelButonDisable(true);
    alert.show("Siparişiniz İptal Ediliyor...");

    let cancelBody = {
      cancelNote: cancelNote.message,
      cancelReasonId: cancelNote.id,
    };

    await axios
      .post(
        `https://getirs2.sambapos.com/food-orders/${orderCancelId}/cancel`,
        cancelBody,
        {
          headers: {
            token: token,
          },
        }
      )
      .then(async () => {
        await axios
          .get(`https://getirs2.sambapos.com/v1/${orderCancelId}/800`)
          .then(async () => {
            await axios
              .post(`https://getirs2.sambapos.com/cancelReason`, {
                cancelReason: cancelNote.message,
                foodOrderId: orderCancelId,
                licenseEmail: resInfo.licenseEmail,
              })
              .then(async () => {
                setChosenModalItem("");
                setShow(false);
                setCancelReason([]);
                getList();
                setCancelButonDisable(false);
              });
          });
      })
      .catch((err) => {
        setShow(false);
        setCancelButonDisable(false);
        alert.show(err.response.data.error);
      });
  };

  const restaurantStateFunc = async (i) => {
    if (i === true) {
      await axios
        .put(
          "https://getirs2.sambapos.com/restaurants/status/close",
          { emailState: resInfo.email },
          {
            headers: {
              token: token,
            },
          }
        )
        .then((res) => {
          if (res.data === "Service Error") {
            setRestaurantState(true);
            alert.show(
              "Getir servislerine ulaşılamadı.Lütfen daha sonra tekrar deneyiniz."
            );
            getList();
          } else {
            setRestaurantState(false);
          }
        })
        .catch((err) => {
          setRestaurantState(true);
          alert.show(
            "Restoran durumu değiştirilemedi.Lütfen tekrar deneyiniz."
          );
          getList();
        });
    }

    if (i === false) {
      await axios
        .put(
          "https://getirs2.sambapos.com/restaurants/status/open",
          { emailState: resInfo.email },
          {
            headers: {
              token: token,
            },
          }
        )
        .then(async (res) => {
          await axios
            .post(
              "https://getirs2.sambapos.com/restaurants/courier/enable",
              { emailState: resInfo.email },
              {
                headers: {
                  token: token,
                },
              }
            )
            .then(() => {
              if (res.data === "Service Error") {
                setRestaurantState(false);
                alert.show(
                  "Getir servislerine ulaşılamadı.Lütfen daha sonra tekrar deneyiniz."
                );
                getList();
              } else {
                setCourierState(true);
                setRestaurantState(true);
              }
            })
            .catch((err) => {
              setRestaurantState(false);
              alert.show(
                "Kurye durumu değiştirilemedi.Lütfen tekrar deneyiniz."
              );
              getList();
            });
        })
        .catch((err) => {
          setRestaurantState(false);
          alert.show(
            "Restoran durumu değiştirilemedi.Lütfen tekrar deneyiniz."
          );
          getList();
        });
    }
  };

  const courierStateFunc = async (i) => {
    if (i === true) {
      await axios
        .post(
          "https://getirs2.sambapos.com/restaurants/courier/disable",
          { emailState: resInfo.email },
          {
            headers: {
              token: token,
            },
          }
        )
        .then((res) => {
          if (res.data === "Service Error") {
            setCourierState(true);
            alert.show(
              "Getir servislerine ulaşılamadı.Lütfen daha sonra tekrar deneyiniz."
            );
            getList();
          } else {
            setCourierState(false);
          }
        })
        .catch((err) => {
          setCourierState(true);
          alert.show("Kurye durumu değiştirilemedi.Lütfen tekrar deneyiniz.");
          getList();
        });
    }

    if (i === false) {
      await axios
        .post(
          "https://getirs2.sambapos.com/restaurants/courier/enable",
          { emailState: resInfo.email },
          {
            headers: {
              token: token,
            },
          }
        )
        .then((res) => {
          if (res.data === "Service Error") {
            setCourierState(false);
            alert.show(
              "Getir servislerine ulaşılamadı.Lütfen daha sonra tekrar deneyiniz."
            );
            getList();
          } else {
            setCourierState(true);
          }
        })
        .catch((err) => {
          setCourierState(false);
          alert.show("Kurye durumu değiştirilemedi.Lütfen tekrar deneyiniz.");
          getList();
        });
    }
  };

  const autoConfirmFunc = async (i) => {
    if (i === false) {
      await axios
        .post("https://getirs2.sambapos.com/restaurants/autoConfirm/enable", {
          l_email: resInfo.licenseEmail,
          token: token,
        })
        .then(() => {
          setAutoConfirm(true);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    if (i === true) {
      await axios
        .post("https://getirs2.sambapos.com/restaurants/autoConfirm/disable", {
          l_email: resInfo.licenseEmail,
        })
        .then(() => {
          setAutoConfirm(false);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  return (
    <div
      className="tab-content card pt-5"
      id="myTabContentMD"
      style={{ minHeight: 100 + "vh" }}
    >
      <TabBar
        showType={showType}
        item1={"Menü Eşleştirme"}
        item1Route={"/menuchain"}
        item2={"Ayarlar"}
        item2Route={"/settings"}
        pageName={"order"}
      />
      <div style={{ width: "100%", marginTop: 20 }}>
        <div className="clearfix"></div>
        <div className="panel-group" id="accordion">
          <IstaCarousel
            totalOrder={totalOrder}
            todayOrder={todayOrder}
            totalOrderPrice={totalOrderPrice}
            todayOrderPrice={todayOrderPrice}
          />
          <div className="panel panel-default">
            <div className="panel-heading" role="tab" id="headingTwo">
              <h4 className="panel-title">
                <a
                  style={{
                    fontWeight: 400,
                    fontSize: 14,
                    backgroundColor: "#fff",
                  }}
                  className="collapsed"
                  role="button"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseTwo"
                  aria-expanded="true"
                  aria-controls="collapseTwo"
                >
                  Seçenekler
                </a>
              </h4>
            </div>
            <div
              id="collapseTwo"
              className="panel-collapse collapse in show"
              role="tabpanel"
              aria-labelledby="headingTwo"
            >
              <div className="panel-body">
                <div className="row" id="restaurantStatus">
                  <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                    <div className="card overflow-hidden">
                      <div className="card-header custom-header autocheck-radio-button">
                        <div>
                          <h6 className="card-title">Otomatik Onay</h6>
                        </div>
                        <div className="card-options">
                          <SwitchButton
                            checked={autoConfirm}
                            onlabel="Açık"
                            offlabel="Kapalı"
                            size="xs"
                            onstyle="success"
                            offstyle="danger"
                            width={90}
                            onChange={() => autoConfirmFunc(autoConfirm)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-12 col-md-12 col-lg-6 col-xl-4">
                    <div className="card overflow-hidden">
                      <div className="card-header custom-header ">
                        <div>
                          <h6 className="card-title"> Restoran Durumu </h6>
                        </div>
                        <div className="card-options">
                          <SwitchButton
                            checked={restaurantState}
                            onlabel="Açık"
                            offlabel="Kapalı"
                            size="xs"
                            onstyle="success"
                            offstyle="danger"
                            width={90}
                            onChange={() =>
                              restaurantStateFunc(restaurantState)
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-12 col-md-12 col-lg-6 col-xl-4">
                    <div className="card overflow-hidden">
                      <div className="card-header custom-header ">
                        <div>
                          <h6 className="card-title"> Restoran Kurye </h6>
                        </div>
                        {restaurantState === true ? (
                          <div className="card-options">
                            <SwitchButton
                              checked={courierState}
                              onlabel="Müsait"
                              offlabel="Yok"
                              size="xs"
                              onstyle="success"
                              offstyle="danger"
                              width={90}
                              onChange={() => courierStateFunc(courierState)}
                            />
                          </div>
                        ) : (
                          <div className="card-options">
                            <span>Restoran Kapalı</span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`tab-pane fade ${showType === 0 && "show active"}`}
        id="newOrders-md"
        role="tabpanel"
        aria-labelledby="newOrders-tab-md"
        style={{ textAlignLast: "center" }}
      >
        <table
          className="table table-striped table-bordered table-hover table-lg"
          cellSpacing="0"
          width="100%"
        >
          <thead>
            <tr>
              <th style={{ fontWeight: 500 }}>Sipariş Tarihi</th>
              <th style={{ fontWeight: 500 }}>Müşteri Adı</th>
              <th style={{ fontWeight: 500 }}>Telefon</th>
              <th style={{ fontWeight: 500 }}>Adres / Bölge</th>
              <th style={{ fontWeight: 500 }}>Adres Açıklama</th>
              <th style={{ fontWeight: 500 }}>Sipariş Detayı</th>
              <th style={{ fontWeight: 500 }}>Ödeme Şekli/Fiyat</th>
              <th style={{ fontWeight: 500 }}>Kurye</th>
              <th style={{ fontWeight: 500 }}>Onay Durumu</th>
            </tr>
          </thead>
          {data.reverse().map((orders, index) => {
            return (
              orders.order_state === 400 && (
                <tbody key={index}>
                  <tr id="newOrdersRow">
                    <td>
                      {moment(orders.createdAt).locale("tr").format("L")}
                      <br />
                      {moment(orders.createdAt).locale("tr").format("LTS")}
                    </td>
                    <td>{orders.client_name}</td>
                    <td>{orders.client_phone_number}</td>
                    <td>{orders.delivery_address}</td>
                    <td>{orders.delivery_address_description}</td>

                    <td>
                      <span className="productInfo">
                        {orders.products.map((product, ind) => {
                          return (
                            <div key={ind}>
                              {product.count} Adet {product.name.tr}
                            </div>
                          );
                        })}
                        <br />
                      </span>
                      <div style={{ textAlign: "center", padding: 3 }}>
                        <OverlayTrigger
                          trigger={["hover", "click"]}
                          placement={"left"}
                          rootClose={true}
                          overlay={
                            <Tooltip id={`tooltip-left`}>
                              {orders.client_note === "" ||
                              orders.client_note === null
                                ? "Sipariş notu bulunmamaktadır."
                                : orders.client_note}
                            </Tooltip>
                          }
                        >
                          <button
                            style={{
                              fontWeight: 500,
                              textDecoration: "underline",
                              color: "#1948d2",
                              backgroundColor: "transparent",
                              borderWidth: 0,
                            }}
                          >
                            Sipariş Notu
                          </button>
                        </OverlayTrigger>
                      </div>
                    </td>
                    <td href="/orderDetail">
                      {orders.total_discounted_price !== null
                        ? orders.total_discounted_price
                        : orders.total_price}{" "}
                      ₺
                      <br />
                      {orders.payment_method_text_tr}
                      <br />
                      <span>
                        <i
                          style={{ color: "#80858a" }}
                          className={
                            orders.payment_method_text_tr ===
                            "Kredi Kartı - Online"
                              ? "fas fa-coins"
                              : orders.payment_method_text_tr ===
                                "Kredi Kartı - Kapıda"
                              ? "fas fa-credit-card"
                              : orders.payment_method_text_tr === "Nakit"
                              ? "fas fa-coins"
                              : "fas fa-credit-card"
                          }
                        ></i>
                        <br />
                        <OverlayTrigger
                          trigger={["hover", "click"]}
                          placement={"left"}
                          rootClose={true}
                          overlay={
                            <Tooltip id={`tooltip-left`}>
                              {orders.payment_method_text_tr}.Lütfen sipariş
                              notunu getiriniz.
                            </Tooltip>
                          }
                        >
                          <button
                            style={{
                              color: "#1948d2",
                              fontWeight: 500,
                              backgroundColor: "transparent",
                              borderWidth: 0,
                            }}
                          >
                            Detaylar
                          </button>
                        </OverlayTrigger>
                      </span>
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {orders.courier_name}
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <button
                        type="button"
                        onClick={() => admitButton(orders)}
                        className="btn btn-green btn-rounded btn-sm m-1 approve-buttons"
                        style={{ borderRadius: 7, width: 126 }}
                        disabled={butonDisable === true ? true : false}
                      >
                        <Done style={{ width: 20, marginBottom: 3 }} />
                        <span
                          style={{
                            marginLeft: 3,
                            fontSize: 14,
                            textTransform: "capitalize",
                          }}
                        >
                          Onayla
                        </span>
                      </button>

                      <button
                        type="button"
                        onClick={() => cancelOptions(orders.order_id)}
                        className="btn btn-red btn-rounded btn-sm m-1 approve-buttons"
                        style={{ borderRadius: 7 }}
                      >
                        <Close style={{ width: 20, marginBottom: 3 }} />
                        <span style={{ marginLeft: 3, fontSize: 14 }}>
                          İptal Et
                        </span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              )
            );
          })}
        </table>
      </div>
      <div
        className={`tab-pane fade ${showType === 1 && "show active"}`}
        id="approved-md"
        role="tabpanel"
        aria-labelledby="approved-tab-md"
        style={{ textAlignLast: "center" }}
      >
        <table
          id="dtBasicExample"
          className="table table-striped table-bordered table-hover table-lg "
          cellSpacing="0"
          width="100%"
          style={{ textAlign: "center" }}
        >
          <thead>
            <tr>
              <th style={{ fontWeight: 500 }}>Sipariş No</th>
              <th style={{ fontWeight: 500 }}>Sipariş Tarihi</th>
              <th style={{ fontWeight: 500 }}>Müşteri Adı</th>
              <th style={{ fontWeight: 500 }}>Bölge</th>
              <th style={{ fontWeight: 500 }}>Tutar</th>
              <th style={{ fontWeight: 500 }}>Sipariş Durumu</th>
              <th style={{ fontWeight: 500 }}>Onay Durumu</th>
            </tr>
          </thead>
          {data.map((orders, index) => {
            return (
              (orders.order_state === 500 || orders.order_state === 600) && (
                <tbody key={index}>
                  <tr id="approvedOrdersRow">
                    <td>{orders.order_id}</td>
                    <td>
                      {moment(orders.createdAt).locale("tr").format("L")}
                      <br />
                      {moment(orders.createdAt).locale("tr").format("LTS")}
                    </td>
                    <td>{orders.client_name}</td>
                    <td>{orders.delivery_address}</td>
                    <td>
                      {orders.total_discounted_price !== null
                        ? orders.total_discounted_price
                        : orders.total_price}{" "}
                      ₺
                    </td>
                    <td>
                      {orders.order_state === 500 ? (
                        <span
                          className="label label-prepare"
                          style={{ color: "#fff" }}
                        >
                          Hazırlanıyor
                        </span>
                      ) : (
                        <span
                          className="label label-approved"
                          style={{ color: "#fff" }}
                        >
                          Müşteriye Gidiyor
                        </span>
                      )}
                    </td>
                    <td>
                      <button
                        type="button"
                        onClick={() => cancelOptions(orders.order_id)}
                        className="btn btn-red btn-rounded btn-sm m-1 approve-buttons"
                        style={{ borderRadius: 7, width: 132 }}
                      >
                        <Close style={{ width: 20, marginBottom: 3 }} />
                        <span style={{ marginLeft: 3, fontSize: 14 }}>
                          İptal Et
                        </span>
                      </button>

                      <button
                        type="button"
                        className="btn btn-blue btn-rounded btn-sm m-1 approve-buttons"
                        onClick={() => history.push("/orderdetail", orders)}
                        style={{ borderRadius: 7 }}
                      >
                        <Visibility style={{ width: 20, marginBottom: 3 }} />
                        <span style={{ marginLeft: 3, fontSize: 14 }}>
                          Detaylar
                        </span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              )
            );
          })}
        </table>
      </div>

      <CancelOrders data={data} showType={showType} />

      <AllOrders data={data} showType={showType} />

      <Modal
        show={show}
        onHide={() => setShow(false)}
        aria-labelledby="exampleModalCenterTitle"
      >
        <Modal.Body className="modal-body">
          <ul className="bg-modal-color rejectdown" style={{ paddingTop: 15 }}>
            <div
              style={{
                textAlign: "center",
                color: "#e20240",
                fontSize: 20,
                fontFamily: "ui-monospace",
                textDecoration: "underline",
              }}
            >
              <span>İptal nedenini seçiniz :</span>
            </div>

            {cancelReason.length === 0 ? (
              <div style={{ color: "black", fontSize: 14 }}>
                İptal nedenlerine ulaşılamadı
              </div>
            ) : (
              cancelReason.map((reasonMessage, ind) => {
                return (
                  <div key={ind}>
                    <li>
                      <button
                        //
                        onClick={() => setChosenModalItem(reasonMessage)}
                        style={{
                          color: "#fff",
                          backgroundColor: "transparent",
                          borderWidth: 0,
                          width: "-webkit-fill-available",
                          textAlign: "left",
                        }}
                      >
                        <RadioGroup
                          value={value}
                          onChange={(event) => setValue(event.target.value)}
                        >
                          <FormControlLabel
                            style={{ color: "black" }}
                            value={reasonMessage.message}
                            control={<Radio />}
                            label={reasonMessage.message}
                            classes={{
                              label: classes.label,
                            }}
                          />
                        </RadioGroup>
                      </button>
                    </li>
                  </div>
                );
              })
            )}
            <li
              style={{
                display: "flex",
                textAlign: "center",
                flexDirection: "row",
                justifyContent: "space-around",
                marginTop: 10,
              }}
            >
              <button
                onClick={() => cancelButton(chosenModalItem)}
                style={{
                  color: "#fff",
                  backgroundColor:
                    cancelButonDisable === false ? "green" : "gray",
                  borderWidth: 0,
                  width: 150,
                  height: 28,
                  font: "small-caption",
                  borderRadius: 20,
                }}
                disabled={cancelButonDisable === true ? true : false}
              >
                <span>Onayla</span>
              </button>
              <button
                onClick={() => (
                  setShow(false), setChosenModalItem(""), setCancelReason([])
                )}
                style={{
                  color: "#fff",
                  backgroundColor: "red",
                  borderWidth: 0,
                  width: 150,
                  height: 28,
                  font: "small-caption",
                  borderRadius: 20,
                }}
              >
                <span>İptal</span>
              </button>
            </li>
          </ul>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Order;
